export default {
  data() {
    return {
      dataTableMobileBreakpoint: '1264',
    };
  },
  computed: {
    size() {
      const size = {
        xs: 'x-small', sm: 'small', lg: 'large', xl: 'x-large',
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    headerButtonSize() {
      const size = {
        xs: 'small', md: 'medium', lg: 'large',
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    circleButtonSize() {
      const size = {
        xs: 'x-small', sm: 'x-small', md: 'small', lg: 'small',
      }[this.$vuetify.breakpoint.name];
      return size ? { [size]: true } : {};
    },
    iconSize() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
          return 'x-large';
        case 'sm':
          return 'x-large';
        default:
          return 'x-large';
      }
    },
    homeCardMinWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return '325px';
        case 'sm': return '500px';
        default: return '600px';
      }
    },
    showTabArrows() {
      let show = false;
      const breakpoint = this.$vuetify.breakpoint.name;

      if (breakpoint === 'xs' || breakpoint === 'sm') show = true;
      return show;
    },
  },
};
